import type { JsonObject } from '@/app-package';
import axios from 'axios';

export type TExportStatus = 'pending' | 'failed' | 'completed';

interface IExportStatus {
  status: TExportStatus;
  fileUrl?: string;
}

const getExportStatus = async (
  taskId: string,
  abortSignal?: AbortSignal,
): Promise<JsonObject<IExportStatus>> => {
  try {
    const url = `/streamchat/export/status?taskId=${taskId}`;

    const { data } = await axios.get<IExportStatus>(url, {
      signal: abortSignal,
    });

    return data;
  } catch (error) {
    console.error(
      `Error checking status of export with taskId: ${taskId}`,
      error,
    );
    throw error;
  }
};

export default getExportStatus;
